module.exports = __webpack_public_path__ + "img/loading-d-dots.acf8e8b6.gif";